import React, {Component} from "react";
import {connect} from "react-redux";
import {epaFetchData} from "../../../actions/epa";

class EpaInformation extends Component {
    componentDidMount() {
        const currentId = this.props.epaId.trim();
        this.props.fetchData(`https://psytable-api.herokuapp.com/api/epa/${currentId}`);
    }

    render() {
        return (
            <section className="epa-information">
                {
                    this.props.epa.map((item, index) => {
                            return (
                                <div className="epa-head" key={index}>
                                    <div className="epa-head__name" >
                                        <span>{item.abbreviation}</span>
                                    </div>
                                    <h1 className="epa-head__headline"  >
                                        {item.nameEpa}
                                    </h1>
                                    <p className="epa-head__description">
                                        {item.description}
                                    </p>
                                </div>
                            )
                        })
                }
                <div className="epa-body">
                    <div className="epa-body__inner">
                        {this.props.epa.map((item, index) => {
                            return(
                                <ul className="epa-body__list" key={index}>
                                    <li className="epa-body__item">
                                        <span className="epa-body__name">Symbol:</span>
                                        <p className="epa-body__description">{item.abbreviation}</p>
                                    </li>
                                    <li className="epa-body__item">
                                        <span className="epa-body__name">Class:</span>
                                        <p className="epa-body__description">{item.classification}</p>
                                    </li>
                                    <li className="epa-body__item">
                                        <span className="epa-body__name">Number:</span>
                                        <p className="epa-body__description">{item.number}</p>
                                    </li>
                                    <li className="epa-body__item">
                                        <span className="epa-body__name">Function:</span>
                                        <p className="epa-body__description">{item.function}</p>
                                    </li>
                                    <li className="epa-body__item">
                                        <span className="epa-body__name">Neurolocalization:</span>
                                        <p className="epa-body__description">{item.neurolocalization}</p>
                                    </li>
                                    <li className="epa-body__item">
                                        <span className="epa-body__name">Neurochem Substrates:</span>
                                        <p className="epa-body__description">{item.neurochemicalSubstrates}</p>
                                    </li>
                                    <li className="epa-body__item">
                                        <span className="epa-body__name">Elicitors:</span>
                                        <p className="epa-body__description">{item.elicitors}</p>
                                    </li>
                                    <li className="epa-body__item">
                                        <span className="epa-body__name">Outputs:</span>
                                        <p className="epa-body__description">{item.outputs}</p>
                                    </li>
                                </ul>
                            )
                        })}

                    </div>
                </div>
            </section>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        epa: state.epa,
        epaItem: state.epaItem
    };
};


const mapDispatchToProps = dispatch => {
    return {
        fetchData: url => dispatch(epaFetchData(url))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EpaInformation);
